import { render, staticRenderFns } from "./GlobalSearchAlert.vue?vue&type=template&id=4048a676&scoped=true&"
import script from "./GlobalSearchAlert.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchAlert.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalSearchAlert.vue?vue&type=style&index=0&id=4048a676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4048a676",
  null
  
)

export default component.exports